import { Injectable } from '@angular/core';

function _window(): any {
  let windowRef = {}
  if (window) {
    windowRef = window;
  }
  return windowRef;
}

@Injectable()
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}
